import React, { useState } from "react";
import {
  ProductImageContainer,
} from "./styles";
import useImageProgressive from "hooks/useImageProgressive";
import { LazyLoadImage } from "react-lazy-load-image-component";
import "react-lazy-load-image-component/src/effects/blur.css";

const ProductImage = ({ image, hoveredImage, altImage, id, imageLow }) => {
  const [imageProduct] = useImageProgressive(
    imageLow,
    image
  );
  const [imageHovered] = useImageProgressive(
    imageLow,
    hoveredImage
  );

  const [hovered, setHovered] = useState(false);

  return (
    <>
      <ProductImageContainer
        onClick={() => window.open("/product/" + id, "_blank")}
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        {/* O fallback anterior era `altImage || NoImage`. Como NoImage é um import
            de imagem, o texto alternativo virava o caminho do arquivo. */}
        <LazyLoadImage
          alt={altImage}
          src={hovered ? imageHovered : imageProduct}
          effect="blur"
        />
      </ProductImageContainer>
    </>
  );
};

export default ProductImage;